import axios from "axios";
import {
  setAccountToken,
  getAccountToken,
  setAccountName,
  setUserGroup,
  setUserId,
  setUserDealerId,
  setUserDistributorId,
  setUserAccessRoles,
} from "./storage";

const apiURL = process.env.REACT_APP_API_URL;

export const headers = (type = null) => {
  if (type === "auth-only") {
    return {
      headers: {
        Authorization: `Bearer ${getAccountToken()}`,
      },
    };
  } else {
    return {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${getAccountToken()}`,
      },
    };
  }
};

export const loginRequest = async (input_data) => {
  try {
    return await axios.post(apiURL + "distributorDealerLogin", input_data);
  } catch (error) {
    //
  }
};

export const postRequest = (ep) =>
  axios.post(apiURL + ep, "", headers("auth-only"));

export const getRequest = (ep) => axios.get(apiURL + ep, headers());

export const postRequestWithData = (ep, data) =>
  axios.post(apiURL + ep, data, headers("auth-only"));

export const deleteRequest = (ep) =>
  axios.delete(apiURL + ep, headers("auth-only"));

export const logoutRequest = () =>
  axios.post(apiURL + "clearLoginTime", "", headers("auth-only"));
